
export default {
  name: 'MahallaIcon'
}
